import React, { Component } from "react";
import PropTypes from "prop-types";
import { ErrorMessage, SuccessMessage, WarningMessage } from "./messages";

export default class Notifications extends Component {
  renderNotification(notification) {
    const { removeNotification } = this.props;

    let MessageComponent = ErrorMessage;
    if (notification.type === "success") {
      MessageComponent = SuccessMessage;
    } else if (notification.type === "warning") {
      MessageComponent = WarningMessage;
    }

    return (
      <MessageComponent
        id={notification.id}
        key={notification.id}
        header={notification.title}
        content={notification.content}
        removeNotification={removeNotification}
      />
    );
  }

  render() {
    const { notifications, className } = this.props;
    return (
      <div id="notifications" className={className}>
        {notifications.map((message) => this.renderNotification(message))}
      </div>
    );
  }
}

Notifications.propTypes = {
  className: PropTypes.string,
  /* Redux */
  notifications: PropTypes.array,
  removeNotification: PropTypes.func.isRequired,
};

Notifications.defaultProps = {
  notifications: [],
  className: "",
};
